import { supabase } from "../supabaseClient.jsx";

export const BABA_PLACEHOLDER = "/assets/img-baba-transparente.webp";

function buildBucketUrl(bucket, path) {
  try {
    const { data } = supabase.storage.from(bucket).getPublicUrl(path);
    return data?.publicUrl || "";
  } catch {
    return "";
  }
}

export function getBabaPhotoCandidates(fotoUrl) {
  if (!fotoUrl || typeof fotoUrl !== "string") {
    return [BABA_PLACEHOLDER];
  }

  if (fotoUrl.startsWith("http") || fotoUrl.startsWith("/")) {
    return [fotoUrl, BABA_PLACEHOLDER];
  }

  // Ordem: bucket atual (fotos-perfil) e bucket legado (cadastros).
  const candidates = [
    buildBucketUrl("fotos-perfil", fotoUrl),
    buildBucketUrl("cadastros", fotoUrl),
    BABA_PLACEHOLDER,
  ].filter(Boolean);

  return [...new Set(candidates)];
}

export function handleBabaPhotoError(event, candidates) {
  const nextIndex = Number(event.currentTarget.dataset.fallbackIndex || "0") + 1;
  if (!Array.isArray(candidates) || nextIndex >= candidates.length) return;

  event.currentTarget.dataset.fallbackIndex = String(nextIndex);
  event.currentTarget.src = candidates[nextIndex];
}
